import memoize from 'lodash/memoize';

export const getFileLink = memoize((file: File) => {
    const link = URL.createObjectURL(file);
    return link;
});
